import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <a href="#home" className="logo">
          <div className="logo-icon">NG</div>
          <span className="logo-text">Nodex Global</span>
        </a>
        
        <nav className={`nav ${isOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li><a href="#home" className="nav-link" onClick={() => setIsOpen(false)}>Home</a></li>
            <li><a href="#about" className="nav-link" onClick={() => setIsOpen(false)}>About Us</a></li>
            <li><a href="#services" className="nav-link" onClick={() => setIsOpen(false)}>Services</a></li>
            <li><a href="#process" className="nav-link" onClick={() => setIsOpen(false)}>Our Process</a></li>
            <li><a href="#reviews" className="nav-link" onClick={() => setIsOpen(false)}>Testimonials</a></li>
          </ul>
          
          {/* Mobile CTA */}
          <div className="mobile-cta">
            <a href="#contact" className="btn btn-primary w-100" onClick={() => setIsOpen(false)}>
              Get Free Quote
            </a>
          </div>
        </nav>

        <div className="header-action">
          <a href="#contact" className="btn btn-primary">
            Start Project <span className="arrow">→</span>
          </a>
        </div>

        <button 
          className={`mobile-toggle ${isOpen ? 'active' : ''}`} 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
